import { defineMessages } from "react-intl"

export default defineMessages({
  aaaMembershipGetADiscountOnAllTrips: {
    defaultMessage: "AAA Membership get a 10% discount on all trips",
    id: "src.components.ProfilePanel.aaaMembershipGetADiscountOnAllTrips",
  },
  aaaMembershipNumber: {
    defaultMessage: "AAA Membership Number",
    id: "src.components.ProfilePanel.aaaMembershipNumber",
  },
  additionalInformation: {
    defaultMessage: "Additional Information",
    id: "src.components.ProfilePanel.additionalInformation",
  },
  addPaymentMethod: {
    defaultMessage: "Add Payment Method",
    id: "src.components.ProfilePanel.addPaymentMethod",
  },
  businessEmail: {
    defaultMessage: "Business email: ",
    id: "src.components.ProfilePanel.businessEmail",
  },
  businessInviteCode: {
    defaultMessage: "Business invite code",
    id: "src.components.ProfilePanel.businessInviteCode",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "src.components.ProfilePanel.cancel",
  },
  default: {
    defaultMessage: "Default",
    id: "src.components.ProfilePanel.default",
  },
  dataPrivacy: {
    defaultMessage: "Data Privacy",
    id: "src.components.ProfilePanel.dataPrivacy",
  },
  deleteCard: {
    defaultMessage: "Delete",
    id: "src.components.ProfilePanel.deleteCard",
  },
  didYouReceiveAnInviteCode: {
    defaultMessage: "Did you receive an invite code? If so, enter it here.",
    id: "src.components.ProfilePanel.didYouReceiveAnInviteCode",
  },
  externalDriverId: {
    defaultMessage: "Fiscal Code",
    id: "src.components.ProfilePanel.externalDriverId",
  },
  externalDriverIdRequired: {
    defaultMessage: "Fiscal Code required",
    id: "src.components.ProfilePanel.externalDriverIdRequired",
  },
  externalDriverIdShouldBeAlphaNumeric: {
    defaultMessage:
      "Fiscal Code must contain alpha numeric characters only a-z A-Z 0-9",
    id: "src.components.ProfilePanel.externalDriverIdShouldBeAlphaNumeric",
  },
  email: {
    defaultMessage: "Email: ",
    id: "src.components.ProfilePanel.email",
  },
  endingIn: {
    defaultMessage: "Ending In ",
    id: "src.components.ProfilePanel.endingIn",
  },
  externalMembershipNumberIsRequired: {
    defaultMessage: "External membership number is required",
    id: "src.components.ProfilePanel.externalMembershipNumberIsRequired",
  },
  mailingAddress: {
    defaultMessage: "Mailing Address",
    id: "src.components.ProfilePanel.mailingAddress",
  },
  membershipNumberMustBeDigits: {
    defaultMessage: "Membership number must be 16 digits",
    id: "src.components.ProfilePanel.membershipNumberMustBeDigits",
  },
  membershipNumberShouldBeDigits: {
    defaultMessage: "Membership number should be digits",
    id: "src.components.ProfilePanel.membershipNumberShouldBeDigits",
  },
  membershipNumberShouldStartsWithEither: {
    defaultMessage: "Membership number should starts with either 620 or 429",
    id: "src.components.ProfilePanel.membershipNumberShouldStartsWithEither",
  },
  mobile: {
    defaultMessage: "Mobile : ",
    id: "src.components.ProfilePanel.mobile",
  },
  paymentMethods: {
    defaultMessage: "Payment Methods",
    id: "src.components.ProfilePanel.paymentMethods",
  },
  phoneNumber: {
    defaultMessage: "Phone Number",
    id: "src.components.ProfilePanel.phoneNumber",
  },
  phoneNumberIsRequired: {
    defaultMessage: "Phone number is required",
    id: "src.components.ProfilePanel.phoneNumberIsRequired",
  },
  profile: {
    defaultMessage: "Profile",
    id: "src.components.ProfilePanel.profile",
  },
  resetPassword: {
    defaultMessage: "RESET PASSWORD",
    id: "src.components.ProfilePanel.resetPassword",
  },
  required: {
    defaultMessage: "Required",
    id: "src.components.ProfilePanel.required",
  },
  signOut: {
    defaultMessage: "SIGN OUT",
    id: "src.components.ProfilePanel.signOut",
  },
  successfullySent: {
    defaultMessage: "An {communication} has successfully been sent!",
    id: "src.components.ProfilePanel.successfullySent",
  },
  update: {
    defaultMessage: "UPDATE",
    id: "src.components.ProfilePanel.update",
  },
  updatesSavedSuccessfully: {
    defaultMessage: "Updates saved successfully!",
    id: "src.components.ProfilePanel.updatesSavedSuccessfully",
  },
})
